module.exports = __webpack_public_path__ + "img/zhittya.8581986b.png";